import React from "react";

function Pagination({
  currentPage,
  getPaginationGroup,
  pages,
  setCurrentPage,
}) {
  // 현재페이지 State props필요
  const next = () => {
    setCurrentPage((page) => page + 1);
  };

  const prev = () => {
    setCurrentPage((page) => page - 1);
  };

  const handleActive = (item) => {
    setCurrentPage(item);
  };

  return (
    <>
      <ul className="pagination justify-content-start">
        {getPaginationGroup.length <= 0 ? null : (
          <li onClick={prev} className="page-item">
            {currentPage === 1 ? null : (
              <a className="page-link">
                <i className="fi-rs-angle-double-small-left"></i>
              </a>
            )}
          </li>
        )}

        {getPaginationGroup.map((item, index) => {
          return (
            <li
              onClick={() => handleActive(item)}
              key={index}
              className={
                currentPage === item ? "page-item active" : "page-item"
              }
            >
              <a className="page-link">{item}</a>
            </li>
          );
        })}

        {getPaginationGroup.length <= 0 ? null : (
          <li onClick={next} className="page-item">
            {currentPage >= pages ? null : (
              <a className="page-link">
                <i className="fi-rs-angle-double-small-right"></i>
              </a>
            )}
          </li>
        )}

        {getPaginationGroup.length <= 0 ? null : (
          <li className="d-flex align-items-center ml-10">
            {currentPage} / {pages}
          </li>
        )}
      </ul>
    </>
  );
}

export default Pagination;
